import { Injectable } from '@angular/core';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { ITodoListEditItem, ITodoListItem, ITodoListViewer } from '@fi-app/fi-onboarding/fi-todo/fi-todo';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class FiTodoService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    getTodosListData(parameter: IItemsListParameterBase) {
        const promise = this.fiBackend.fetchDataPost<IItemsListDataFetchResult<ITodoListItem>>(
            'Onboarding/Todo/GetTodosListData',
            parameter,
        );
        return promise;
    }

    saveTodoList(todoListItem: ITodoListEditItem) {
        const promise = this.fiBackend.fetchDataPost<number>('Onboarding/Todo/SaveTodoList', todoListItem);
        return this.fiLoading.trackPromise(promise);
    }

    getTodoList(todoListId: number) {
        return this.fiBackend.fetchDataPost<ITodoListEditItem>(`Onboarding/Todo/GetTodoList/${todoListId}`);
    }

    getTodoListViewer(todoListId: number) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<ITodoListViewer>(`Onboarding/Todo/GetTodoListViewer/${todoListId}`),
        );
    }

    getTodoListCopy(todoListId: number) {
        return this.fiBackend.fetchDataPost<ITodoListEditItem>(`Onboarding/Todo/GetTodoListCopy/${todoListId}`);
    }

    deleteTodoLists(todoListIds: number[]) {
        const promise = this.fiBackend.fetchDataPost<void>('Onboarding/Todo/DeleteTodoLists', todoListIds);
        return this.fiLoading.trackPromise(promise);
    }
}
